export default class Anchor {
  constructor({trigger, position} = Object.prototype) {
    this.trigger = document.querySelector(trigger);
    this.position = position === 'top' ? 0
                    : position === 'main' ? document.querySelector('.main').offsetTop
                    : null;

    this.scrollTo = this.scrollTo.bind(this);

    if (this.trigger) this.init();
  };

  init() {
    this.bind();
  };

  bind() {
    this.trigger.addEventListener('click', this.scrollTo);
  };

  scrollTo(e) {
    e.preventDefault();
    window.scrollTo({ top: this.position, behavior: 'smooth' });
  };
};